<template>
    <div :class="(selected && !disabled) ? 'tw:bg-zinc-50 tw:dark:bg-zinc-800' : ''">
        <div class="d-flex justify-content-between w-full tw:gap-2">
          <div class="tw:flex tw:items-center tw:gap-2 tw:flex-wrap tw:min-w-0">
            <div class="form-check tw:min-w-0">
              <input type="checkbox"
                     v-model="selected"
                     :id="'parkCheck' + park.id"
                     :disabled="disabled"
                     class="form-check-input">
              <label class="form-check-label"
                     :for="'parkCheck' + park.id">
                <strong>{{ ownerable }}</strong> : {{ park.name }}
              </label>
            </div>
            <slot name="badge" />
          </div>
          <div
            class="tw:shrink-0 tw:flex tw:items-center tw:gap-1 tw:text-xs"
            :class="countColorClass"
          >
            <component :is="countIcon" class="tw:size-3.5" />
            <span>{{ $t('items_count', {count: park.active_equipments_count}, park.active_equipments_count) }}</span>
          </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { PackageIcon, AlertTriangleIcon } from '@lucide/vue';

const props = defineProps({
  ownerable: {
    type: String,
    default: '',
  },
  park: {
    type: Object,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['updateSelectedPark']);

const selected = ref(props.isSelected);

watch(() => props.isSelected, (val) => {
  selected.value = val;
});

watch(selected, (val) => {
  emit('updateSelectedPark', val);
});

const isEmpty = computed(() => props.park?.active_equipments_count === 0);

const countIcon = computed(() => (selected.value && isEmpty.value) ? AlertTriangleIcon : PackageIcon);

const countColorClass = computed(() => {
  if (selected.value && isEmpty.value) return 'tw:text-red-600 tw:dark:text-red-400';
  if (selected.value) return 'tw:text-green-600 tw:dark:text-green-400';
  if (isEmpty.value) return 'tw:text-zinc-400 tw:dark:text-zinc-500';
  return 'tw:text-zinc-500 tw:dark:text-zinc-400';
});
</script>

<style scoped>

</style>